import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SocialMediaLinksProps {
	socialMediaLinks: {
		url: string;
		icon: IconDefinition;
	}[];
	className?: string;
	linkClassName?: string;
	iconClassName?: string;
}

export const SocialMediaLinks = ({ socialMediaLinks, className, linkClassName, iconClassName }: SocialMediaLinksProps) => {
	const handleOpenSocialMedia = (url: string, event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation();
		event.preventDefault();

		window.open(url, '_blank');
	};

	return (
		<div className={className}>
			{socialMediaLinks
				.filter((link) => link.url)
				.map(({ url, icon }) => (
					<div key={url} onClick={(e) => handleOpenSocialMedia(url, e)} role="presentation" className={`cursor-pointer ${linkClassName}`}>
						<FontAwesomeIcon icon={icon} className={`size-5 ${iconClassName}`} />
					</div>
				))}
		</div>
	);
};
